import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import "./invite-friends.css";
import { Button, Box, Grid, Pagination, Stack } from "@mui/material";
import FacebookIcon from "./../../../assets/svg/facebook.svg";
import LinkdinIcon from "./../../../assets/svg/linkdin.svg";
import TwitterIcon from "./../../../assets/svg/twitter.svg";
import WhatsappIcon from "./../../../assets/svg/whatsapp.svg";
import InviteFriendsImage from "./../../../assets/images/invite-friends.png";
import ProfileImage from "./../../../assets/images/ProfileImage.png";
let InviteFriends = () => {
  let TableData = [
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      media: "whatsapp",
      country: "burnside",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      media: "whatsapp",
      country: "burnside",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      media: "whatsapp",
      country: "burnside",
      status: "Inactive",
    },

    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      media: "whatsapp",
      country: "burnside",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      media: "whatsapp",
      country: "burnside",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      media: "whatsapp",
      country: "burnside",
      status: "Inactive",
    },
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      media: "whatsapp",
      country: "burnside",
      status: "Active",
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <div className="invite-friends-header-section">
          <h1 id="invite-friend-heading">Invite Friend</h1>
          <p id="invite-friend-message">
            Donec enim lectus, venenatis nec aliquam a, varius sed ex. Ut
            laoreet augue velit, vel malesuada elit euismod ut. Nam at dui eros.
            Vivamus sem quam, tincidunt a urna congue, malesuada consectetur
            leo. Donec ornare consectetur ante, ac viverra arcu rhoncus ac
          </p>
          <div id="invite-friend-copy-link-main">
            <p id="invite-friend-copy-link">
              {`<a href="http://" style="font-size: 11px;" target="_self">Example Text</a>`}
            </p>
            <Button className="invite-friend-copy-link-button" variant="text">
              copy
            </Button>
          </div>
          <div id="invite-friend-share-main">
            <h1 id="invite-friend-share-heading">Share with your friends</h1>
            <div id="invite-friend-share-button-main">
              <Button className="invite-friend-share-button" variant="text">
                <img src={FacebookIcon} />
              </Button>
              <Button className="invite-friend-copy-link-button" variant="text">
                <img src={LinkdinIcon} />
              </Button>
              <Button className="invite-friend-copy-link-button" variant="text">
                <img src={TwitterIcon} />
              </Button>
              <Button className="invite-friend-copy-link-button" variant="text">
                <img src={WhatsappIcon} />
              </Button>
            </div>
          </div>
          <div id="invite-friend-image-main">
            <img src={InviteFriendsImage} id="invite-friend-image" />
          </div>
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">Search by Student name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by student name"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">Search by Country</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by Country"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="invite-friend-table-id-heading">ID</th>
                <th className="invite-friend-table-date-heading">Date</th>
                <th className="invite-friend-table-name-heading">Name</th>
                <th className="invite-friend-table-socila-media-heading">
                  Social media
                </th>
                <th className="invite-friend-table-country-heading">Country</th>
                <th className="invite-friend-table-status-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableIndex + 1}</td>
                    <td className="table-data">{tableValue.date}</td>
                    <td className="table-data">
                      <div id="invite-friend-table-prifile-main">
                        <img
                          src={ProfileImage}
                          alt="Profile Image"
                          id="invite-friend-table-prifile-image"
                        />
                        <p id="invite-friend-table-user-name">
                          {tableValue.name}
                        </p>
                      </div>
                    </td>
                    <td className="table-data">{tableValue.media}</td>
                    <td className="table-data">{tableValue.country}</td>
                    <td className="table-data">
                      <div
                        className="invite-friends-table-button"
                        style={{
                          backgroundColor:
                            tableValue.status === "Active"
                              ? "#D2FFEB"
                              : "#FFB0B0",
                        }}
                      >
                        <p
                          className="table-data-button-title"
                          style={{
                            color:
                              tableValue.status === "Active"
                                ? "#098B51"
                                : "#B80000",
                          }}
                        >
                          {tableValue.status}
                        </p>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default InviteFriends;
